module.exports = __webpack_public_path__ + "img/news_banner.72130866.png";